import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri } from "../../utilities/apiManager";

export const fetchManagementConfig = createAsyncThunk(
  "management/fetchConfig",
  async (countryCode, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth?.accessToken;
      const { data } = await axios.get(
        `${apiUri}/management?country=${countryCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": "Bearer " + token,
            "Accept-Language": document.documentElement.lang || "en",
          },
        }
      );
      return thunkAPI.fulfillWithValue(data.data?.[0]);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const submitManagementConfig = createAsyncThunk(
  "management/submitConfig",
  async (payload, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth?.accessToken;
      const { data } = await axios.post(`${apiUri}/management`, payload, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": "Bearer " + token,
          "Accept-Language": document.documentElement.lang || "en",
        },
      });
      return thunkAPI.fulfillWithValue(data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const managementSlice = createSlice({
  name: "management",
  initialState: {
    config: null,
    loading: false,
    submitting: false,
    error: null,
  },
  reducers: {
    clearManagementState: (state) => {
      state.config = null;
      state.loading = false;
      state.submitting = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManagementConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManagementConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(fetchManagementConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(submitManagementConfig.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(submitManagementConfig.fulfilled, (state) => {
        state.submitting = false;
      })
      .addCase(submitManagementConfig.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  },
});

export const { clearManagementState } = managementSlice.actions;
export default managementSlice.reducer;
